import { VFC } from 'react'
import { CustomLinkify } from 'src/components/Linkify'
import { orange, _profilehrborder } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'

type EventDetailListItemProps = {
  title: string
  description: string
}

export const EventDetailListItem: VFC<EventDetailListItemProps> = ({
  title,
  description,
}) => (
  <ListItem>
    <h3>{title}</h3>
    <CustomLinkify>{description}</CustomLinkify>
  </ListItem>
)

const ListItem = styled.li`
  display: block;
  margin-bottom: 32px;
  font-weight: ${fontWeightBold};
  letter-spacing: 0.05em;

  h3 {
    color: ${orange};
    font-size: 18px;
    padding-bottom: 16px;
    margin-bottom: 16px;
    position: relative;
  }
  h3::before {
    content: '';
    background-image: linear-gradient(
      to right,
      ${_profilehrborder},
      ${_profilehrborder} 5px,
      transparent 5px,
      transparent 10px
    );
    background-size: 10px 1px;
    background-position: left bottom;
    background-repeat: repeat-x;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    pointer-events: none;
  }
  p {
    font-size: 14px;
  }
  a {
    color: ${orange};
    text-decoration: underline;
  }
`
